import { useGetCardOnlineTransactionsQuery } from "@/modules/card/services";
import { HistoryDetail } from "@/shared/components";
import { getFormattedHistoryList } from "@/shared/helpers";
import { useMemo } from "react";

interface Props {
  cardId?: string;
}

export const CardDetailOnlineHistory = ({ cardId = "" }: Props) => {
  const { data: cardHistory, isFetching } = useGetCardOnlineTransactionsQuery(
    { cardId },
    {
      refetchOnMountOrArgChange: true,
    }
  );

  const historyList = useMemo(() => {
    return getFormattedHistoryList({
      list: cardHistory ?? [],
    });
  }, [cardHistory]);

  return (
    <HistoryDetail
      isFetching={isFetching}
      historyList={historyList}
    />
  );
};
